import { FC } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";

import { ABTestListPageContainer_Query } from "~/src/__relay_artifacts__/ABTestListPageContainer_Query.graphql";
import { ListFilterFormValues as FormValues } from "~/src/components/features/filter";
import { useListFilterCache } from "~/src/lib/hooks";

import { ABTestListPage } from "./presentations";

const query = graphql`
  query ABTestListPageContainer_Query(
    $siteSlug: String!
    $pageIds: [ID!]
    $funnelIds: [ID!]
    $pageKind: PageKind
    $sourceId: ID
    $device: Device
    $withArchived: Boolean
    $status: DistributionStatus
  ) {
    viewer {
      role
    }
    site(slug: $siteSlug) {
      name
      ...ABTestListPage_site
        @arguments(
          pageIds: $pageIds
          funnelIds: $funnelIds
          pageKind: $pageKind
          sourceId: $sourceId
          device: $device
          withArchived: $withArchived
          status: $status
        )
    }
  }
`;

export const ABTestListPageContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => {
  const { siteSlug = "" } = useParams();
  const initialFilterFormValues: FormValues = {
    pageIds: [],
    funnelIds: [],
    pageKind: null,
    sourceId: null,
    device: null,
    withArchived: null,
    status: null,
  };
  const { filterValues, setFilterValues } = useListFilterCache({
    cacheKey: `ABTestListPage_${siteSlug}`,
    initialFilterValues: initialFilterFormValues,
  });
  const { site, viewer } = useLazyLoadQuery<ABTestListPageContainer_Query>(
    query,
    {
      siteSlug,
      ...filterValues,
    }
  );

  return (
    <ABTestListPage
      siteRef={site}
      role={viewer.role}
      filterValues={filterValues}
      setFilterValues={setFilterValues}
    />
  );
};
